import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useModalsContext } from '@/contexts/ModalsContext';

export default function CancelarEventoPublicadoTerminos() {
    // Contextos
    const { closeModal } = useModalsContext();
    // Estado para el checkbox de términos y condiciones
    const [aceptaTerminos, setAceptaTerminos] = useState(false);
  return (
    <div className="bg-aw-bluedark p-6 rounded-lg text-center inset-shadow-sm inset-shadow-aw-green/60">
      <h2 className="text-2xl font-semibold mb-4 text-white">
        Confirmar Cancelación
      </h2>
      <p className="text-white mb-6">
        ¿Estás seguro de que deseas cancelar este evento?
        <br />
        Esta acción no se puede deshacer y debes aceptar los términos y
        condiciones.
      </p>
      <div className="mb-4 max-h-[50dvh] overflow-auto scrollbar-box bg-aw-blueblack p-2 sm:p-6 rounded-2xl">
        {/* Aquí hay que agregar los términos y condiciones o cualquier otro contenido relevante */}
        <p className="text-white whitespace-break-spaces text-justify">
          Términos y condiciones de cancelación: - Esta acción no se puede
          deshacer. - Debes aceptar los términos y condiciones para continuar.
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Harum debitis
          obcaecati recusandae delectus numquam nesciunt porro at
          necessitatibus, vitae, cumque dignissimos optio repellendus accusamus
          quidem nisi ex? Accusamus, inventore dolor. Modi, impedit, laudantium
          accusamus soluta nostrum aperiam ratione odit fugit eligendi deserunt
          amet sed. Pariatur animi atque iure ipsum alias fugit dolorum facilis
          soluta commodi? Veritatis voluptate fuga nesciunt commodi? <br />
          <br />
          Fuga, odit quod molestiae doloremque dicta vero perspiciatis quasi! Ad
          rem esse facilis neque ipsam corporis quidem! Eligendi, molestiae hic
          dolores ducimus maxime quod officiis deleniti eaque consequatur qui
          et. Reprehenderit similique amet distinctio, ipsum atque sint veniam
          possimus vitae quo voluptas ut minima explicabo placeat, ipsa
          veritatis eveniet laudantium quibusdam? Laudantium sit eos nobis,
          minus provident temporibus quisquam corrupti.
          <br />
          <br />
          Architecto at accusamus eum, quod non necessitatibus autem harum
          debitis molestias voluptates, quas alias delectus assumenda? Atque
          harum nesciunt eius iure iste magni ratione cupiditate! Ex iusto
          suscipit provident iure! Ex placeat, sapiente dolorem voluptates autem
          voluptatum beatae corporis molestiae incidunt quidem, magnam,
          similique itaque quisquam at! Recusandae porro neque, voluptates
          dolorum nostrum omnis vero ipsum optio cumque. Vero, quis.
          <br />
          <br />
          Necessitatibus hic nobis, ipsum possimus esse aperiam fuga neque
          commodi sequi incidunt cupiditate amet ipsa odio optio vitae maiores
          repellat consequatur architecto temporibus impedit exercitationem
          nostrum laborum. Qui, magni ipsa? Quibusdam qui numquam molestias
          illum? Eos qui, vel dolores explicabo voluptatem iste necessitatibus
          dolore minus minima debitis reiciendis ex deserunt nesciunt aspernatur
          a numquam, quasi voluptates amet quam facilis sapiente! Nam repellat
          harum molestias doloribus repudiandae. Voluptatem sed consequuntur id
          dolor! Aut, error facere. Ipsum est, beatae quibusdam repudiandae vel
          doloremque ipsa optio exercitationem molestiae, minima omnis dolore,
          quos quo! Culpa ipsam odio illo eligendi assumenda eum porro natus,
          dolorum veniam cum quod autem veritatis, fugiat delectus officiis
          laudantium? Eligendi magnam pariatur hic fugit! Obcaecati, tempora
          impedit? Esse, perspiciatis voluptas? Culpa ullam a aspernatur sint
          fuga sit aperiam molestiae nostrum! Amet excepturi assumenda atque
          perspiciatis aut, nam voluptate possimus a doloremque earum officiis
          dolor quasi ipsum reprehenderit molestiae vel delectus? Doloribus,
          nobis molestias aspernatur, eaque explicabo ad dicta laborum
          consequuntur dolores molestiae error at repudiandae, culpa numquam
          dolorum praesentium accusantium ab vel asperiores reprehenderit
          quisquam sint! Quae dolores ducimus ratione!
          <br />
          <br />
          Veniam nostrum repellat est aperiam dolores ratione! Nam atque laborum
          expedita magnam maxime ipsum illum asperiores. Minus ab unde corporis
          vel facilis, modi voluptates libero minima. Maxime qui minima tempore.
          Recusandae voluptatem voluptatibus quo optio delectus similique at
          amet porro labore! Natus harum nulla, cumque corporis eum deleniti.
          Deserunt illum iste mayores ipsam ipsum recusandae vero non tempora
          optio id. Molestiae ullam earum cumque exercitationem assumenda
          nesciunt, sit natus corporis explicabo a maiores tempora nobis
          sapiente id. Reiciendis, veniam repellat ipsam obcaecati, vitae
          delectus vero rerum veritatis, ipsa in porro?
        </p>
        {/* Modern Checkbox para aceptar términos y condiciones */}
        <div className="flex items-center justify-center mb-4 mt-6">
          <div className="relative flex items-center">
            <input
              type="checkbox"
              id="terms"
              className="sr-only peer"
              checked={aceptaTerminos}
              onChange={() => setAceptaTerminos(!aceptaTerminos)}
            />
            <label
              htmlFor="terms"
              className={`relative flex items-center justify-center w-5 h-5 border-2 rounded cursor-pointer transition-all duration-200 ${
                aceptaTerminos
                  ? "bg-aw-green border-aw-green"
                  : "bg-transparent border-gray-400 hover:border-aw-green"
              } group`}
            >
              {aceptaTerminos && (
                <FontAwesomeIcon
                  icon={"fa-solid fa-check"}
                  className="text-aw-bluedark text-xs transition-opacity duration-200 pointer-events-none"
                />
              )}
            </label>
          </div>
          <label
            htmlFor="terms"
            className="ml-3 text-sm text-white cursor-pointer select-none"
          >
            Acepto los términos y condiciones
          </label>
        </div>
      </div>
      <div className="flex justify-end">
        <button
          onClick={() => {
            if (aceptaTerminos) {
              // Aquí va la lógica para cancelar el evento
              closeModal("cancelar");
              setTimeout(() => {
                window.location.reload();
              }, 500);
            }
          }}
          className={` text-white font-semibold py-2 px-4 rounded mr-2 transition-colors duration-200 ${
            aceptaTerminos
              ? "bg-red-600 hover:bg-red-700"
              : "opacity-50 cursor-not-allowed"
          }`}
          disabled={!aceptaTerminos}
        >
          Cancelar Evento
        </button>
        <button
          onClick={() => closeModal("cancelar")}
          className="bg-gray-500 hover:bg-gray-600 text-white font-semibold py-2 px-4 rounded transition-colors duration-200"
        >
          Regresar
        </button>
      </div>
    </div>
  );
}
